import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { ActivityTypesRoughState } from './types';

const actions: ActionTree<ActivityTypesRoughState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
